
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $4jwPl = parcelRequire("4jwPl");
var $45OZf = parcelRequire("45OZf");

var $d7X2q = parcelRequire("d7X2q");
var $0cd09b181f9d53e0$exports = {};
$0cd09b181f9d53e0$exports = "#define GLSLIFY 1\nuniform sampler2D uTexture;\nuniform vec2 uOffset;\nvarying vec2 vUv;\n\nfloat M_PI = 3.141529;\n\nvec3 deformationCurve(vec3 position, vec2 uv, vec2 offset){\n    position.x = position.x + (sin(uv.y * M_PI) * offset.x);\n    position.y = position.y + (sin(uv.x * M_PI) * offset.y);\n    return position;\n}\n\nvoid main(){\n    vUv = uv;\n    vec3 newPosition = deformationCurve(position, uv, uOffset);\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(newPosition, 1.0) * 0.9;\n}";


var $5cf63b10e237d158$exports = {};
$5cf63b10e237d158$exports = "#define GLSLIFY 1\nuniform sampler2D uTexture;\nuniform float uAlpha;\nuniform vec2 uOffset;\nvarying vec2 vUv;\n\nvec3 rgbShift(sampler2D textureimage, vec2 uv, vec2 offset ){\n    vec2 uvR = clamp(uv + offset, 0.0, 1.0);\n    vec2 uvGB = clamp(uv, 0.0, 1.0);\n\n    float r = texture2D(textureimage, uvR).r;\n    vec2 gb = texture2D(textureimage, uvGB).gb;\n\n    return vec3(r, gb);\n}\n\nvoid main(){\n    // vec3 color = texture2D(uTexture, vUv).rgb;\n    vec3 color = rgbShift(uTexture, vUv, uOffset);\n    color = clamp(color, 0.0, 1.0);\n    gl_FragColor = vec4(color, clamp(uAlpha, 0.0, 1.0));\n}\n";


const $f509029d5cc53467$var$loader = new $4jwPl.TextureLoader();
const $f509029d5cc53467$var$texture = $f509029d5cc53467$var$loader.load((0, $d7X2q.default).me);
const $f509029d5cc53467$var$texture2 = $f509029d5cc53467$var$loader.load((0, $d7X2q.default).me2);
const $f509029d5cc53467$var$texture3 = $f509029d5cc53467$var$loader.load((0, $d7X2q.default).dev);
const $f509029d5cc53467$var$texture4 = $f509029d5cc53467$var$loader.load((0, $d7X2q.default).NY);
const $f509029d5cc53467$var$DEBUG_HOVER_IMAGE = false;
function $f509029d5cc53467$var$lerp(start, end, t) {
    return start * (1 - t) + end * t;
}
class $f509029d5cc53467$var$shaded {
    constructor(){
        this.container = document.querySelector(".landing");
        this.inner = document.querySelector(".intro");
        this.links = [
            ...document.querySelectorAll("#shadedimg")
        ];
        this.hovered = false;
        this.targetX = 0;
        this.targetY = 0;
        this.targetAlpha = 0;
        this.scene = new $4jwPl.Scene();
        this.perspective = 1000;
        this.sizes = new $45OZf.Vector2(0, 0);
        this.offset = new $45OZf.Vector2(0, 0);
        this.uniforms = {
            uTexture: {
                value: $f509029d5cc53467$var$texture4
            },
            uAlpha: {
                value: 0.0
            },
            uOffset: {
                value: new $45OZf.Vector2(0.0, 0.0)
            }
        };
        this.links.map((link, i)=>{
            link.addEventListener("mouseenter", ()=>{
                this.hovered = true;
                this.targetAlpha = 1.0;
                switch(i){
                    case 0:
                        this.uniforms.uTexture.value = $f509029d5cc53467$var$texture;
                        break;
                    case 1:
                        this.uniforms.uTexture.value = $f509029d5cc53467$var$texture2;
                        break;
                    case 2:
                        this.uniforms.uTexture.value = $f509029d5cc53467$var$texture3;
                        break;
                    case 3:
                        this.uniforms.uTexture.value = $f509029d5cc53467$var$texture4;
                        break;
                }
                if ($f509029d5cc53467$var$DEBUG_HOVER_IMAGE) console.log('hover image enter', {
                    index: i,
                    alpha: this.uniforms.uAlpha.value,
                    texture: this.uniforms.uTexture.value?.source?.data?.currentSrc || this.uniforms.uTexture.value?.image?.currentSrc || this.uniforms.uTexture.value?.image?.src
                });
            });
            link.addEventListener('mouseleave', ()=>{
                this.targetAlpha = 0.0;
                if ($f509029d5cc53467$var$DEBUG_HOVER_IMAGE) console.log('hover image leave', {
                    index: i,
                    alpha: this.uniforms.uAlpha.value
                });
            });
        });
        this.checkHovered();
        this.setupCamera();
        this.followMouseMove();
        this.createMesh();
        this.render();
    }
    get viewport() {
        let width = window.innerWidth;
        let height = window.innerHeight;
        let aspectRatio = width / height;
        let pixelRatio = window.devicePixelRatio;
        return {
            width: width,
            height: height,
            aspectRatio: aspectRatio,
            pixelRatio: pixelRatio
        };
    }
    checkHovered() {
        this.inner.addEventListener("mouseenter", ()=>{
            this.hovered = true;
            this.targetAlpha = 1.0;
        });
        this.inner.addEventListener("mouseleave", ()=>{
            this.hovered = false;
            this.targetAlpha = 0.0;
            this.uniforms.uTexture.value = $f509029d5cc53467$var$texture;
        });
    }
    setupCamera() {
        window.addEventListener("resize", this.onResize.bind(this));
        let fov = 180 * (2 * Math.atan(this.viewport.height / 2 / this.perspective)) / Math.PI;
        this.camera = new $45OZf.PerspectiveCamera(fov, this.viewport.aspectRatio, 0.1, 1000);
        this.camera.position.set(0, 0, this.perspective);
        // Create a renderer
        this.renderer = new $45OZf.WebGLRenderer({
            antialias: true,
            alpha: true
        });
        this.renderer.setClearColor(0x000000, 0);
        this.renderer.setSize(this.viewport.width, this.viewport.height);
        this.renderer.setPixelRatio(this.viewport.pixelRatio);
        this.renderer.domElement.style.position = 'absolute';
        this.renderer.domElement.style.top = '0';
        this.renderer.domElement.style.left = '0';
        this.renderer.domElement.style.pointerEvents = 'none';
        this.renderer.domElement.style.background = 'transparent';
        this.renderer.domElement.style.zIndex = '1';
        this.container.appendChild(this.renderer.domElement);
    }
    createMesh() {
        this.geometry = new $45OZf.PlaneGeometry(1, 1, 20, 20);
        this.material = new $45OZf.ShaderMaterial({
            uniforms: this.uniforms,
            vertexShader: (0, (/*@__PURE__*/$parcel$interopDefault($0cd09b181f9d53e0$exports))),
            fragmentShader: (0, (/*@__PURE__*/$parcel$interopDefault($5cf63b10e237d158$exports))),
            transparent: true
        });
        this.mesh = new $45OZf.Mesh(this.geometry, this.material);
        this.sizes.set(220, 280, 1);
        this.mesh.scale.set(this.sizes.x, this.sizes.y, 1);
        this.mesh.position.set(this.offset.x, this.offset.y, 0);
        this.scene.add(this.mesh);
    }
    followMouseMove() {
        window.addEventListener("mousemove", (e)=>{
            this.targetX = e.clientX;
            this.targetY = e.clientY;
        });
    }
    onResize() {
        this.camera.aspect = this.viewport.aspectRatio;
        this.camera.fov = 180 * (2 * Math.atan(this.viewport.height / 2 / this.perspective)) / Math.PI;
        this.renderer.setSize(this.viewport.width, this.viewport.height);
        this.camera.updateProjectionMatrix();
    }
    render() {
        this.offset.x = $f509029d5cc53467$var$lerp(this.offset.x, this.targetX, 0.1);
        this.offset.y = $f509029d5cc53467$var$lerp(this.offset.y, this.targetY, 0.1);
        this.uniforms.uOffset.value.set((this.targetX - this.offset.x) * 0.0003, -(this.targetY - this.offset.y) * 0.0003);
        this.mesh.position.set(this.offset.x - window.innerWidth / 2, -this.offset.y + window.innerHeight / 2);
        this.uniforms.uAlpha.value = $f509029d5cc53467$var$lerp(this.uniforms.uAlpha.value, this.targetAlpha, 0.1);
        if ($f509029d5cc53467$var$DEBUG_HOVER_IMAGE && Math.abs(this.uniforms.uAlpha.value - this.targetAlpha) > 0.001) console.log('hover image alpha', {
            current: this.uniforms.uAlpha.value,
            target: this.targetAlpha
        });
        this.renderer.render(this.scene, this.camera);
        window.requestAnimationFrame(this.render.bind(this));
    }
}
new $f509029d5cc53467$var$shaded();


//# sourceMappingURL=portfolio-site-test.e0b32d31.js.map
